import ApiClient from 'clients/api_client'
import Modal from 'react-overlays/lib/Modal'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { setModalStyle } from 'supports/modal_style_helper'

export default class UserNoticeContentHistoryDeleteModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isFetching: false,
      isOpened: false
    }
  }

  show() {
    this.setState(
      {
        isOpened: true
      },
      () => setModalStyle(this.modal)
    )
  }

  hide() {
    this.setState({
      isOpened: false
    })
  }

  handleSubmit() {
    const { url } = this.props
    this.setState({
      isFetching: true
    })

    ApiClient.delete(url).then(() => window.location.reload())
  }

  render() {
    const { confirm_message: confirmMessage, delete_button_text: buttonText, title } = this.props
    const { isFetching, isOpened } = this.state

    return (
      <Fragment>
        <button type="button" className="btn btn-default-delete" onClick={() => this.show()}>
          {buttonText}
        </button>

        <Modal show={isOpened} onShow={() => setModalStyle(this.modal)}>
          <div className="modal modal-delete">
            <div className="modal-bg" onClick={() => this.hide()} role="presentation" />
            <div
              className="modal-in"
              ref={ref => {
                this.modal = ref
              }}
            >
              <div className="modal-header">
                <div className="title">{title}</div>
              </div>
              <div className="modal-content">
                <div className="modal-form">
                  <div>{confirmMessage}</div>
                </div>
                <div className="modal-submit">
                  <button
                    type="button"
                    className="btn btn-delete"
                    onClick={e => this.handleSubmit(e)}
                    disabled={isFetching}
                  >
                    {isFetching
                      ? I18n.t('components.user_notice_content_history_delete_modal.button.deleting')
                      : buttonText}
                  </button>
                  <button type="button" className="btn btn-default" disabled={isFetching} onClick={() => this.hide()}>
                    {I18n.t('common.button.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}

UserNoticeContentHistoryDeleteModal.propTypes = {
  url: PropTypes.string.isRequired,
  delete_button_text: PropTypes.string,
  title: PropTypes.string,
  confirm_message: PropTypes.string
}

UserNoticeContentHistoryDeleteModal.defaultProps = {
  // TODO [locales] I18nを呼べるようにしてから対応 common.button.delete
  delete_button_text: '削除',
  // TODO [locales] I18nを呼べるようにしてから対応 components.user_notice_content_history_delete_modal.title
  title: '削除の確認',
  // TODO [locales] I18nを呼べるようにしてから対応 components.user_notice_content_history_delete_modal.message.delete.confirm
  confirm_message: '本当に削除しますか？'
}
